import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            浏览分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            按分类查找你感兴趣的吉泽明步相关内容，涵盖个人资料、演艺经历、代表作品及更多
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => {
            const isAccent = cat.color === 'accent';
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group relative bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-background-300/60 transition-all duration-300"
              >
                <div className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl mb-4 transition-all duration-300 ${
                  isAccent
                    ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50'
                    : 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                }`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1.5 text-sm md:text-base group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}